$(document).ready(function () {
  $(".form-business").hide();
  $("#successMessage").hide();

  $(".nextfirststep").on({
    click: function () {
      $('#progressList-1').removeClass('active');
      $('#progressList-1').addClass('done');
      // select any card
      var childName = $("#child_name").val();
      var childBirthdate = $("#child_birthdate").val();

      if (childName !== '' && childBirthdate !== '') {
        $("#child_name").css('border-bottom', '');
        $("#child_birthdate").css('border-bottom', '');
        $("#progressList-2").addClass("active");
        $(".secondstepwizard .cb-level-image").addClass('cb-hidden');
        $(".secondstepwizard .list-columns").addClass('cb-hidden');

        $('#cb-2nd-step-child-name').html(childName);

        if ($.cookie('discount_code') !== null) {
          if ($.cookie('discount_code') === 'sibling10') {
            $('.secondstepwizard .coupon-text.for-learn-subscription').show();
            $('.secondstepwizard .oxford-block.for-learn-subscription').show();
            $('.secondstepwizard .description-info.for-learn-subscription').show();
            $('.secondstepwizard .card-body').show();
            $('.secondstepwizard .checkout_suggested_info').show();
            $('.secondstepwizard .coupon-text.for-gift-subscription').hide();
            $('.secondstepwizard .oxford-block.for-gif-subscription').hide();
            $('.secondstepwizard .description-info.for-gift-subscription').hide();
          } else {
            $('.secondstepwizard .coupon-text.for-learn-subscription').hide();
            $('.secondstepwizard .oxford-block.for-learn-subscription').hide();
            $('.secondstepwizard .description-info.for-learn-subscription').hide();
            $('.secondstepwizard .card-body').hide();
            $('.secondstepwizard .checkout_suggested_info').hide();
            $('.secondstepwizard .coupon-text.for-gift-subscription').show();
            $('.secondstepwizard .oxford-block.for-gif-subscription').show();
            $('.secondstepwizard .description-info.for-gift-subscription').show();
          }
        } else {
          $('.secondstepwizard .coupon-text.for-learn-subscription').show();
          $('.secondstepwizard .oxford-block.for-learn-subscription').show();
          $('.secondstepwizard .description-info.for-learn-subscription').show();
          $('.secondstepwizard .card-body').show();
          $('.secondstepwizard .checkout_suggested_info').show();
          $('.secondstepwizard .coupon-text.for-gift-subscription').hide();
          $('.secondstepwizard .oxford-block.for-gif-subscription').hide();
          $('.secondstepwizard .description-info.for-gift-subscription').hide();
        }

        var startSchool = $('input[name="start-school"]:checked').val();
        var currentSchoolYear = $('input[name="school-year"]:checked').val();
        var forcePrereception = false;

        if (currentSchoolYear === 'prereception') {
          startSchool = $('#start-school-1').val();
          forcePrereception = true;
        }
        
        var birthdate = new Date($('#child_birthdate').val());
        var today = new Date();
        var academicToday = new Date();
    
        academicToday.setMonth(8, 1);
        var monthsToSeptember = (today.getFullYear() - academicToday.getFullYear()) * 12;
        monthsToSeptember -= academicToday.getMonth();
        monthsToSeptember += today.getMonth();
        if (monthsToSeptember < 0) {
          academicToday.setFullYear(academicToday.getFullYear() - 1);
        }
        if (birthdate.getMonth() === 8) {
          academicToday.setMonth(7, 1);
        }
        const diffTime = Math.abs(academicToday - birthdate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        const yearsAge = diffDays / 365;
    
        var academicMonths = (academicToday.getFullYear() - birthdate.getFullYear()) * 12;
        academicMonths -= birthdate.getMonth();
        academicMonths += academicToday.getMonth();

        if (yearsAge < 4 || forcePrereception) {
          // PR
          $('.resclubname').html('Pre-reading');
          $('.subscription-type').html('Monthly Box');
          var jsonPrProduct = JSON.parse($('#ProductJson-1month').html());
          $('.js-subscription-price').html('£' + (jsonPrProduct.price/100).toFixed(2));

          // FOR TEST
          var data = {};
          data['months'] = academicMonths;
          data['startSchool'] = startSchool;
          data['currentSchoolYear'] = '';
          $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
            if (response !== false && response !== 0 && response !== '0') {
              responseJson = JSON.parse(response);
              var bandName = responseJson[5];
              if (bandName === 'default') {
                $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + responseJson[9]);
              } else {
                $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + bandName + '/' + responseJson[9]);
              }

              if (responseJson[3].toLowerCase() === 'baby bear') {
                $(".secondstepwizard .whats-included-bb").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'cub') {
                $(".secondstepwizard .whats-included-cub").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'teddy') {
                $(".secondstepwizard .whats-included-teddy").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'grizzly') {
                $(".secondstepwizard .whats-included-grizzly").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'mountain bear') {
                $(".secondstepwizard .whats-included-mb").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'koala' || responseJson[3].toLowerCase() === 'honey') {
                $(".secondstepwizard .whats-included-koala-honey").removeClass('cb-hidden');
              } else if (responseJson[3].toLowerCase() === 'panda') {
                $(".secondstepwizard .whats-included-panda").removeClass('cb-hidden');
              }
              
              if (responseJson[0] === '18') {
                $('.subscription-type').html('Bi-monthly Box');
              } else {
                $('.subscription-type').html('Monthly Box');
              }
              
              // alert(responseJson[1] + ' ' + responseJson[3]  + ' ' + responseJson[5]  + ' ' + responseJson[6]);
            }
          });
          // ENDFORTEST
        } else {
          var data = {};
          data['months'] = academicMonths;
          data['startSchool'] = '';
          data['currentSchoolYear'] = currentSchoolYear;
          var currentSchoolYearTitle = currentSchoolYear;
          var monthly = false;
          var bimonthly = false;
          if (currentSchoolYear === 'reception') {
            currentSchoolYearTitle = 'Reception';
            monthly = true;
            bimonthly = false;
          } else if (currentSchoolYear === 'year1') {
            currentSchoolYearTitle = 'Year 1';
            monthly = true;
            bimonthly = false;
          } else if (currentSchoolYear === 'year2') {
            currentSchoolYearTitle = 'Year 2';
            monthly = true;
            bimonthly = false;
          } else if (currentSchoolYear === 'year3') {
            currentSchoolYearTitle = 'Year 3';
            monthly = false;
            bimonthly = true;
          } else if (currentSchoolYear === 'year4') {
            currentSchoolYearTitle = 'Year 4';
            monthly = false;
            bimonthly = true;
          } else if (currentSchoolYear === 'year5') {
            currentSchoolYearTitle = 'Year 5';
            monthly = false;
            bimonthly = true;
          }

          if (monthly && !bimonthly) {
            $('.resclubname').html('Learning to Read');
            $('.subscription-type').html('Monthly Box');
            var jsonLrProduct = JSON.parse($('#ProductJson-1month').html());
            $('.js-subscription-price').html('£' + (jsonLrProduct.price/100).toFixed(2));
  
            // FOR TEST
            var data = {};
            data['months'] = academicMonths;
            data['startSchool'] = '';
            data['currentSchoolYear'] = currentSchoolYear;
            $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
              if (response !== false && response !== 0 && response !== '0') {
                responseJson = JSON.parse(response);
                var bandName = responseJson[5];
                if (bandName === 'default') {
                  $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + responseJson[9]);
                } else {
                  $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + bandName + '/' + responseJson[9]);
                }
                if (responseJson[0] === '18') {
                  $('.subscription-type').html('Bi-monthly Box');
                } else {
                  $('.subscription-type').html('Monthly Box');
                }

                if (responseJson[3].toLowerCase() === 'baby bear') {
                  $(".secondstepwizard .whats-included-bb").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'cub') {
                  $(".secondstepwizard .whats-included-cub").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'teddy') {
                  $(".secondstepwizard .whats-included-teddy").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'grizzly') {
                  $(".secondstepwizard .whats-included-grizzly").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'mountain bear') {
                  $(".secondstepwizard .whats-included-mb").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'koala' || responseJson[3].toLowerCase() === 'honey') {
                  $(".secondstepwizard .whats-included-koala-honey").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'panda') {
                  $(".secondstepwizard .whats-included-panda").removeClass('cb-hidden');
                }
  
                // alert(responseJson[1] + ' ' + responseJson[3]  + ' ' + responseJson[5]  + ' ' + responseJson[6]);
              }
            });
            // ENDFORTEST
          }

          if (!monthly && bimonthly) {
            $('.resclubname').html('Independent Reading');
            $('.subscription-type').html('Bi-monthly Box');
            var jsonIrProduct = JSON.parse($('#ProductJson-2month').html());
            $('.js-subscription-price').html('£' + (jsonIrProduct.price/100).toFixed(2));
  
            // FOR TEST
            var data = {};
            data['months'] = academicMonths;
            data['startSchool'] = '';
            data['currentSchoolYear'] = currentSchoolYear;
            $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
              if (response !== false && response !== 0 && response !== '0') {
                responseJson = JSON.parse(response);
                var bandName = responseJson[5];
                if (bandName === 'default') {
                  $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + responseJson[9]);
                } else {
                  $('.resclubname').html(responseJson[1] + ': ' + responseJson[3] + ', ' + bandName + '/' + responseJson[9]);
                }
                if (responseJson[0] === '18') {
                  $('.subscription-type').html('Bi-monthly Box');
                } else {
                  $('.subscription-type').html('Monthly Box');
                }

                if (responseJson[3].toLowerCase() === 'baby bear') {
                  $(".secondstepwizard .whats-included-bb").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'cub') {
                  $(".secondstepwizard .whats-included-cub").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'teddy') {
                  $(".secondstepwizard .whats-included-teddy").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'grizzly') {
                  $(".secondstepwizard .whats-included-grizzly").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'mountain bear') {
                  $(".secondstepwizard .whats-included-mb").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'koala' || responseJson[3].toLowerCase() === 'honey') {
                  $(".secondstepwizard .whats-included-koala-honey").removeClass('cb-hidden');
                } else if (responseJson[3].toLowerCase() === 'panda') {
                  $(".secondstepwizard .whats-included-panda").removeClass('cb-hidden');
                }
  
                // alert(responseJson[1] + ' ' + responseJson[3]  + ' ' + responseJson[5]  + ' ' + responseJson[6]);
              }
            });
            // ENDFORTEST
          }
        }
        
        $(this).parents(".row").fadeOut("slow", function () {
          $(this).next(".row").fadeIn("slow");
        });
      } else {
        if (childName === '') {
          $("#child_name").css('border-bottom', '2px red solid');
          $("<p style='color:#ea4040; margin-top:10px;'>Please enter your child's name to proceed.</p>").insertAfter('#child_name')
        } else {
          $("#child_name").css('border-bottom', '');
        }
        if (childBirthdate === '') {
          $("#child_birthdate").css('border-bottom', '2px red solid');
        } else {
          $("#child_birthdate").css('border-bottom', '');
        }
      }
    }
  });

  $(".back").on({
    click: function () {
      $("#progressList-2").removeClass("active");
      $(this).parents(".row").fadeOut("slow", function () {
        $(this).prev(".row").fadeIn("slow");
      });
    }
  });

  var todayDate = new Date();
  var startStudyYear = new Date();
  startStudyYear.setMonth(8, 1);

  neededStartData = new Date();
  if (startStudyYear < todayDate) {
    neededStartData.setFullYear(todayDate.getFullYear() + 1);
  }

  $('#start-school-0').val(neededStartData.getFullYear() - 1);
  $('label[for="start-school-0"]').html(neededStartData.getFullYear() - 1);
  $('#start-school-1').val(neededStartData.getFullYear());
  $('label[for="start-school-1"]').html(neededStartData.getFullYear());
  $('#start-school-2').val(neededStartData.getFullYear() + 1);
  $('label[for="start-school-2"]').html(neededStartData.getFullYear() + 1);
  $('#start-school-3').val(neededStartData.getFullYear() + 2);
  $('label[for="start-school-3"]').html(neededStartData.getFullYear() + 2);
  $('#start-school-4').val(neededStartData.getFullYear() + 3);
  $('label[for="start-school-4"]').html(neededStartData.getFullYear() + 3);
  $('#start-school-5').val(neededStartData.getFullYear() + 4);
  $('label[for="start-school-5"]').html(neededStartData.getFullYear() + 4);
  
  $('#child_birthdate').change(function() {
    var childName = $("#child_name").val();
    var birthdate = new Date($(this).val());
    var today = new Date();
    var academicToday = new Date();
    var lifeToday = new Date();

    academicToday.setMonth(8, 1);
    var monthsToSeptember = (today.getFullYear() - academicToday.getFullYear()) * 12;
    monthsToSeptember -= academicToday.getMonth();
    monthsToSeptember += today.getMonth();
    if (monthsToSeptember < 0) {
      academicToday.setFullYear(academicToday.getFullYear() - 1);
    }
    if (birthdate.getMonth() === 8) {
      academicToday.setMonth(7, 1);
    }
    const diffTime = Math.abs(academicToday - birthdate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    const yearsAge = diffDays / 365;

    var academicMonths = (academicToday.getFullYear() - birthdate.getFullYear()) * 12;
    academicMonths -= birthdate.getMonth();
    academicMonths += academicToday.getMonth();

    var lifeMonths = (lifeToday.getFullYear() - birthdate.getFullYear()) * 12;
    lifeMonths -= birthdate.getMonth();
    lifeMonths += lifeToday.getMonth();

    $('.underlowerage').hide();
    $('.startschoolyear').hide();
    $('.currentschoolclass').hide();
    $('.currentschoolclass .school-year-prereception, .currentschoolclass .school-year-reception, .currentschoolclass .school-year-0, .currentschoolclass .school-year-1, .currentschoolclass .school-year-2, .currentschoolclass .school-year-3, .currentschoolclass .school-year-4, .currentschoolclass .school-year-5, .startschoolyear [for="start-school-4"]').addClass('cb-hidden');
    $('.underupperage').hide();
    $('.underupperage').attr('style', 'display: none !important');
    $('.contactuswizard').attr('style', 'display: none !important');
    $('.nextfirststep').addClass('disabled');
    $('.nextfirststep').prop('disabled', 'disabled');

    if (childName !== '') {
      $('.current_schoolyear_child_name').html(childName);
      $('.start_school_child_name').html(childName);
    } else {
      $('.current_schoolyear_child_name').html('your child');
      $('.start_school_child_name').html('your child');
    }

    // console.log(lifeMonths, 'lifeMonths');
    // console.log(yearsAge, 'yearsAge');
    // console.log(monthsToSeptember, 'monthsToSeptember');
    // console.log(academicToday, 'academicToday');

    if (lifeMonths < 1) {
      $('.underlowerage').fadeIn("slow");
    }
    if (lifeMonths > 119) {
      $('.underupperage').fadeIn("slow");
      $('.underupperage').attr('style', 'display: block !important');
      $('.contactuswizard').attr('style', 'display: inline-block !important');
    }
console.log('lifeMonths', lifeMonths, 'yearsAge', yearsAge);
    if (lifeMonths >= 1 && lifeMonths <= 119) {
      if (yearsAge < 1) {
        $('[name="start-school"][id="start-school-4"]').prop('checked', true);
        $('[name="start-school"][id="start-school-0"], .startschoolyear [for="start-school-0"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-1"], .startschoolyear [for="start-school-1"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-2"], .startschoolyear [for="start-school-2"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-3"], .startschoolyear [for="start-school-3"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-4"], .startschoolyear [for="start-school-4"]').removeClass('cb-hidden');
        // $('.startschoolyear').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
      } else if (yearsAge >= 1 && yearsAge < 2) {
        $('[name="start-school"][id="start-school-3"]').prop('checked', true);
        $('[name="start-school"][id="start-school-0"], .startschoolyear [for="start-school-0"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-1"], .startschoolyear [for="start-school-1"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-2"], .startschoolyear [for="start-school-2"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-3"], .startschoolyear [for="start-school-3"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-4"], .startschoolyear [for="start-school-4"]').removeClass('cb-hidden');
        // $('.startschoolyear').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
      } else if (yearsAge >= 2 && yearsAge < 3) {
        $('[name="start-school"][id="start-school-2"]').prop('checked', true);
        $('[name="start-school"][id="start-school-0"], .startschoolyear [for="start-school-0"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-4"], .startschoolyear [for="start-school-4"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-1"], .startschoolyear [for="start-school-1"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-2"], .startschoolyear [for="start-school-2"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-3"], .startschoolyear [for="start-school-3"]').removeClass('cb-hidden');
        // $('.startschoolyear').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
      } else if (yearsAge >= 3 && yearsAge < 4) {
        $('[name="start-school"][id="start-school-1"]').prop('checked', true);
        $('[name="start-school"][id="start-school-0"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-3"], .startschoolyear [for="start-school-3"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-4"], .startschoolyear [for="start-school-4"]').addClass('cb-hidden');
        $('[name="start-school"][id="start-school-0"], .startschoolyear [for="start-school-0"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-1"], .startschoolyear [for="start-school-1"]').removeClass('cb-hidden');
        $('[name="start-school"][id="start-school-2"], .startschoolyear [for="start-school-2"]').removeClass('cb-hidden');
        $('.startschoolyear').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
      } else if (yearsAge >= 4 && yearsAge < 5) {
        $('[name="school-year"][value="reception"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-prereception, .currentschoolclass .school-year-reception, .currentschoolclass .school-year-1').removeClass('cb-hidden');
      } else if (yearsAge >= 5 && yearsAge < 6) {
        $('[name="school-year"][value="year1"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-reception, .currentschoolclass .school-year-1, .currentschoolclass .school-year-2').removeClass('cb-hidden');
      } else if (yearsAge >= 6 && yearsAge < 7) {
        $('[name="school-year"][value="year2"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-1, .currentschoolclass .school-year-2, .currentschoolclass .school-year-3').removeClass('cb-hidden');
      } else if (yearsAge >= 7 && yearsAge < 8) {
        $('[name="school-year"][value="year3"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-2, .currentschoolclass .school-year-3, .currentschoolclass .school-year-4').removeClass('cb-hidden');
      } else if (yearsAge >= 8 && yearsAge < 9) {
        $('[name="school-year"][value="year4"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-3, .currentschoolclass .school-year-4, .currentschoolclass .school-year-5').removeClass('cb-hidden');
      } else if (yearsAge >= 9 && yearsAge < 10) {
        $('[name="school-year"][value="year5"]').prop('checked', true);
        $('.currentschoolclass').fadeIn("slow");
        $('.nextfirststep').removeClass('disabled');
        $('.nextfirststep').prop('disabled', false);
        $('.currentschoolclass .school-year-3, .currentschoolclass .school-year-4, .currentschoolclass .school-year-5').removeClass('cb-hidden');
      }
    }
  });
  

  $('#child_birthdate').click(function() {document.getElementById('child_birthdate').showPicker()});

  $('.contcheckout').click(function() {
    var birthdate = new Date($('#child_birthdate').val());
    var today = new Date();
    var academicToday = new Date();

    academicToday.setMonth(8, 1);
    var monthsToSeptember = (today.getFullYear() - academicToday.getFullYear()) * 12;
    monthsToSeptember -= academicToday.getMonth();
    monthsToSeptember += today.getMonth();
    if (monthsToSeptember < 0) {
      academicToday.setFullYear(academicToday.getFullYear() - 1);
    }
    if (birthdate.getMonth() === 8) {
      academicToday.setMonth(7, 1);
    }
    const diffTime = Math.abs(academicToday - birthdate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    const yearsAge = diffDays / 365;

    var academicMonths = (academicToday.getFullYear() - birthdate.getFullYear()) * 12;
    academicMonths -= birthdate.getMonth();
    academicMonths += academicToday.getMonth();

    var monthsAge = (today.getFullYear() - birthdate.getFullYear()) * 12;
    monthsAge -= birthdate.getMonth();
    monthsAge += today.getMonth();

    $('.progressbar-list').removeClass('active')
    $("#progressList-3").addClass("active");
    $("#progressList-3").removeClass("done");
    $('.contcheckout').addClass('disabled');
    $('.contcheckout').prop('disabled', 'disabled');
    $('.popup-preloader').addClass('cc-popup--visible');

    var childName = $("#child_name").val();
    var childBirthdate = $("#child_birthdate").val();
    var startSchool = $('input[name="start-school"]:checked').val();
    var currentSchoolYear = $('input[name="school-year"]:checked').val();
    var forcePrereception = false;

    if (currentSchoolYear === 'prereception') {
      startSchool = $('#start-school-1').val();
      forcePrereception = true;
    }

    var dataSubscription = {
      quantity: 1
    };

    if (yearsAge < 4 || forcePrereception) {
      var data = {};
      data['months'] = academicMonths;
      data['startSchool'] = startSchool;
      data['currentSchoolYear'] = '';
      $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
        if (response !== false && response !== 0 && response !== '0') {
          responseJson = JSON.parse(response);

          var jsonPrProduct = JSON.parse($('#ProductJson-1month').html());
          dataSubscription.id = jsonPrProduct.variants[0].id;
          dataSubscription.selling_plan = jsonPrProduct.variants[0].selling_plan_allocations[0].selling_plan_id;
          dataSubscription.properties = {
            "Child's Name": childName,
            "Child's Birthday": childBirthdate,
            "Starts School In": startSchool,
            "__Age (months)": monthsAge,
            "__Stage Name": responseJson[1],
            "__Level Name": responseJson[3],
            "__Band Name": responseJson[5],
            "__Box Name": responseJson[6],
            "__Box ID": responseJson[8],
            "__Box Public Name": responseJson[9]
          };

          // console.log(dataSubscription);
          $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            data: dataSubscription,
            dataType: 'json', 
            success: function (dataCleared) {
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: dataSubscription,
                dataType: 'json', 
                success: function (data) {
                  window.location.href = "/checkout";
                } 
              });
            } 
          });
        }
      });
    } else {
      var data = {};
      data['months'] = academicMonths;
      data['startSchool'] = '';
      data['currentSchoolYear'] = currentSchoolYear;
      var currentSchoolYearTitle = currentSchoolYear;
      var monthly = false;
      var bimonthly = false;
      if (currentSchoolYear === 'reception') {
        currentSchoolYearTitle = 'Reception';
        monthly = true;
        bimonthly = false;
      } else if (currentSchoolYear === 'year1') {
        currentSchoolYearTitle = 'Year 1';
        monthly = true;
        bimonthly = false;
      } else if (currentSchoolYear === 'year2') {
        currentSchoolYearTitle = 'Year 2';
        monthly = true;
        bimonthly = false;
      } else if (currentSchoolYear === 'year3') {
        currentSchoolYearTitle = 'Year 3';
        monthly = false;
        bimonthly = true;
      } else if (currentSchoolYear === 'year4') {
        currentSchoolYearTitle = 'Year 4';
        monthly = false;
        bimonthly = true;
      } else if (currentSchoolYear === 'year5') {
        currentSchoolYearTitle = 'Year 5';
        monthly = false;
        bimonthly = true;
      }

      if (monthly && !bimonthly) {
        $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
          if (response !== false && response !== 0 && response !== '0') {
            responseJson = JSON.parse(response);
  
            var jsonLrProduct = JSON.parse($('#ProductJson-1month').html());
            dataSubscription.id = jsonLrProduct.variants[0].id;
            dataSubscription.selling_plan = jsonLrProduct.variants[0].selling_plan_allocations[0].selling_plan_id;
            dataSubscription.properties = {
              "Child's Name": childName,
              "Child's Birthday": childBirthdate,
              "Current School Year": currentSchoolYearTitle,
              "__Age (months)": monthsAge,
              "__Stage Name": responseJson[1],
              "__Level Name": responseJson[3],
              "__Band Name": responseJson[5],
              "__Box Name": responseJson[6],
              "__Box ID": responseJson[8],
              "__Box Public Name": responseJson[9]
            };
  
            // console.log(dataSubscription);
            $.ajax({
              type: 'POST',
              url: '/cart/clear.js',
              data: '',
              dataType: 'json', 
              success: function (dataCleared) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: dataSubscription,
                  dataType: 'json', 
                  success: function (data) {
                    window.location.href = "/checkout";
                  } 
                });
              } 
            });
            
          }
        });
      }

      if (!monthly && bimonthly) {
        $.post('https://alt.cartblender.com/projects/thebearcanread/pub/detect_box_new.php', {data : data}, function(response) {
          if (response !== false && response !== 0 && response !== '0') {
            responseJson = JSON.parse(response);
  
            var jsonIrProduct = JSON.parse($('#ProductJson-2month').html());
            dataSubscription.id = jsonIrProduct.variants[0].id;
            dataSubscription.selling_plan = jsonIrProduct.variants[0].selling_plan_allocations[0].selling_plan_id;
            dataSubscription.properties = {
              "Child's Name": childName,
              "Child's Birthday": childBirthdate,
              "Current School Year": currentSchoolYearTitle,
              "__Age (months)": monthsAge,
              "__Stage Name": responseJson[1],
              "__Level Name": responseJson[3],
              "__Band Name": responseJson[5],
              "__Box Name": responseJson[6],
              "__Box ID": responseJson[8],
              "__Box Public Name": responseJson[9]
            };
  
            // console.log(dataSubscription);
            $.ajax({
              type: 'POST',
              url: '/cart/clear.js',
              data: dataSubscription,
              dataType: 'json', 
              success: function (dataCleared) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: dataSubscription,
                  dataType: 'json', 
                  success: function (data) {
                    window.location.href = "/checkout";
                  } 
                });
              } 
            });
          }
        });
      }
    }
  });


});